/**
 * Settings index page (route: `/settings`).
 *
 * Navigation now lives in the two-pane [`SettingsSidebar`](client/src/components/SettingsSidebar.tsx),
 * so this page just shows a lightweight placeholder until the user picks a
 * category. Selecting an item in the sidebar navigates to its dedicated route.
 */
import { useLocation } from "wouter";
import { Settings as SettingsIcon } from "lucide-react";

export default function SettingsPage() {
  const [location] = useLocation();

  // Only render at the exact /settings root — sub-routes are handled by
  // their own route components.
  if (location !== "/settings") return null;

  return (
    <div className="flex h-full flex-col items-center justify-center text-center">
      <div className="rounded-full bg-primary/10 p-4 text-primary">
        <SettingsIcon className="h-8 w-8" />
      </div>
      <h1 className="mt-4 text-xl font-semibold">Settings</h1>
      <p className="mt-1 max-w-md text-sm text-muted-foreground">
        Pick a category from the sidebar to manage your account, organization,
        operations, integrations, and more.
      </p>
    </div>
  );
}
